import { tokens } from '@arvoreeducacao/bonsai-ds'
import { useLayoutEffect, useState } from 'react'

const useUserPlatform = () => {
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const [isDesktop, setIsDesktop] = useState(false)
  const [isDesktopLarge, setIsDesktopLarge] = useState(false)
  const [isDesktopXLarge, setIsDesktopXLarge] = useState(false)
  const [isSmallerThanTablet, setIsSmallerThanTablet] = useState(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useLayoutEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
      setIsMobile(window.innerWidth < tokens.breakpoints.tabletSmall)
      setIsTablet(
        window.innerWidth >= tokens.breakpoints.tabletSmall &&
          window.innerWidth < tokens.breakpoints.desktop
      )
      setIsSmallerThanTablet(window.innerWidth < tokens.breakpoints.tablet)
      setIsDesktop(
        window.innerWidth >= tokens.breakpoints.desktop &&
          window.innerWidth < tokens.breakpoints.desktopLarge
      )
      setIsDesktopLarge(
        window.innerWidth >= tokens.breakpoints.desktopLarge &&
          window.innerWidth < tokens.breakpoints.desktopXlarge
      )
      setIsDesktopXLarge(window.innerWidth >= tokens.breakpoints.desktopXlarge)
    }

    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return {
    windowWidth,
    isDesktopXLarge,
    isDesktopLarge,
    isDesktop,
    isMobile,
    isTablet,
    isSmallerThanTablet
  }
}

export default useUserPlatform
